import { InstitutionData, ValidatorResponse } from "src/model"
import utility from "./utility";
import jsSHA from 'jssha'
import pako from 'pako';
import imageCompression from 'browser-image-compression';
import { appSettings } from "src/provider/config/constant";

const inputValidator = (data: any, exemptedPropertes?: string[]): ValidatorResponse => {
    var result = <ValidatorResponse>{ isValidated: true }
    for (let key in data) {
        if (!data[key] && !exemptedPropertes?.includes(key)) {
            result.isValidated = false;
            result.message = `Input: Kindly provide 
            "${utility.splitCamelCase(key, true)}"`
            break;
        }
    }
    //console.log({result})
    return result
} 

const validateEmail = (email: string): boolean => {
    return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)
}

const validatePhoneNo = (phoneNo: string) => {
    if (phoneNo.startsWith('+234') || phoneNo.startsWith('234')) {
        phoneNo = phoneNo.replace('+', '')
        phoneNo = phoneNo.replace('234', '0')
    }
    if ((['070', '080', '081', '090', '091'].includes(phoneNo.substring(0, 3))) && phoneNo.length === 11)
        return true;
    else return false
}

const validateBvn = (bvn: string): string|null => {
    let result = null

    if (bvn) {
        if (bvn.length != 11 || !bvn.startsWith('22')) result = null
        else result = bvn
    }

    return result
}

const isValidFileType = (filename: string) => {
    let result = true
    let splittedFileName = filename.split('.')
    let extension = splittedFileName[splittedFileName.length - 1].toLowerCase()
    if (!['png', 'jpg', 'jpeg'].includes(extension)) result = false
        return result
}

const searchTableData = (tableData: any, searchText: string, propertiesTowatch: any[] = [], propertiesToRemove: any[] = []) => {
    let result = []

    if (!propertiesTowatch.length) {
        propertiesTowatch = Object.keys(tableData[0])
    }

    for (let obj of tableData) { 
        for (let key in obj) {
            if (!propertiesToRemove.includes(key) && propertiesTowatch.includes(key)) {
                if (String(obj[key]).toLowerCase().includes(searchText.toLowerCase())) {
                    result.push(obj)
                    break;
                }
            }
        }
    }

    if (result.length < 1) {
        result = tableData
    }

    return result
}

const splitDateTime = (data: string) => {
    // Convert from '2023-08-23T15:28:26.230Z' to other formats
    let [date, time] = data.split('T')
    let [year, month, day] = date.split('-')
    let [hours, minutes] = time.split(':')

    month = (month.length > 1 && month[0] === '0') ? month[1] : month
    const monthShort = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    const formattedHours = (hours.length > 1 && hours[0] === '0') ? hours[1] : hours

    return {
        date: `${monthShort[Number(month)-1]} ${day}, ${year}`,
        slashedDate: `${day}/${month}/${year}`,
        time: `${hours}:${minutes}`,
        timeEnv: `${Number(formattedHours) < 12 ? 'am' : 'pm'}`,
        completeTime: `${hours}:${minutes}${Number(formattedHours) < 12 ? 'am' : 'pm'}`
    }
}

const convertDateTimeToSystemFormat = (data: string) => {
    // Convert '08/25/2023 13:45:18' format to '2023-08-23T15:28:26.230Z'
    const [date, time] = data.split(' ')
    const [month, day, year] = date.split('/')

    return `${year}-${month}-${day}T${time}Z`
}

const hashString = (text: string) => {
    const shaObj = new jsSHA("SHA-512", "TEXT", { numRounds: 64});
    shaObj.update(text)
    return shaObj.getHash("B64")
}

const convertFileToBase64 = (file: any) => {
    return new Promise(resolve => {
        let fileInfo;
        let baseURL: any = "";
        // Make new FileReader
        let reader = new FileReader();

        // Convert the file to base64 text
        reader.readAsDataURL(file);

        // on reader load somthing...
        reader.onload = () => {
            // Make a fileInfo Object
            baseURL = reader.result;
            baseURL = baseURL.replace('data:image/png;base64,', '').replace('data:image/jpeg;base64,', '').replace('data:image/jpg;base64,', '')
            resolve(baseURL);
        };
    });
};

const ConvertBase64toFile = (base64String: string, filename: string, mimeType = 'image/jpeg') => {
    // Decode the Base64 string to binary data
    const binaryString = atob(base64String);
  
    // Create a Uint8Array from the binary data
    const uint8Array = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      uint8Array[i] = binaryString.charCodeAt(i);
    }
  
    // Create a Blob from the Uint8Array
    const blob = new Blob([uint8Array], { type: mimeType });
  
    // Create a File from the Blob
    const file = new File([blob], filename, { type: mimeType });
  
    return file;
  }

const getFileSize = (base64: string) => {
    const sizeInBytes = 4 * Math.ceil((base64.length / 3)) * 0.5624896334383812;
    return (sizeInBytes/1000).toFixed(1);
}

const getAccountDetailsWithAcctNo = (data: any[], acctNo: string) => {
    let accountDetails

    for (let acct of data) {
        if (acct.accountNumber === acctNo) {
            accountDetails = acct
            break
        }
    }

    return accountDetails
}

const getAccountDetailsByParam = (data: any[], property: string, param: string) => {
    let accountDetails

    for (let acct of data) {
        if (acct[property] === param) {
            accountDetails = acct
            break
        }
    }

    return accountDetails
}

const getDateTime = () => {
    let today = new Date();
    let date = today.getFullYear() + '/' + (today.getMonth() + 1) + '/'+today.getDate();
    let hours = today.getHours();
    let minutes: any = today.getMinutes();
    let ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes;
    let strTime = hours + ':' + minutes + ' ' + ampm;

    return `${date} ${strTime}`
}

const getCardExpiryDate = (date: string) => {
    let expiryDate: any = splitDateTime(date)?.slashedDate
    expiryDate = expiryDate.split('/')
    expiryDate[2] = expiryDate[2].substring(2)
    expiryDate = `${expiryDate[1]}/${expiryDate[2]}`

    return expiryDate
}

const convertHexToRGBA = (hexCode: string, opacity?: number|string) => {
    let alpha = false
    let hex: any = hexCode.slice(hexCode.startsWith('#') ? 1 : 0);
    
    if (hex.length === 3) hex = [...hex].map(x => x + x).join('');
    else if (hex.length === 8) alpha = true;

    hex = parseInt(hex, 16);

    return (
        'rgb' +
        (alpha ? 'a' : '') +
        '(' +
        (hex >>> (alpha ? 24 : 16)) +
        ', ' +
        ((hex & (alpha ? 0x00ff0000 : 0x00ff00)) >>> (alpha ? 16 : 8)) +
        ', ' +
        ((hex & (alpha ? 0x0000ff00 : 0x0000ff)) >>> (alpha ? 8 : 0)) +
        (alpha ? `, ${hex & 0x000000ff}` : '') +
        `, ${opacity || 1}` +
        ')'
    );
};

const formatNotification = (notifications: any) => {
    const notifGroup = <any>{}
    const formattedNotifications = []

    for (let notif of notifications) {
        let  notifDate = formatDate(new Date(notif.dateCreated))
        const val = notifGroup[notifDate]
        if(val?.length) notifGroup[notifDate] = sortArrayOfObjects([...val, notif], 'dateCreated')
        else notifGroup[notifDate] = [notif]
    }

    for (let key in notifGroup) {
        formattedNotifications.push({
            date: key,
            info: notifGroup[key]
        })
    }

    console.log({formattedNotifications})

    return formattedNotifications
}

const formatDate = (dateTime: any) => {
    const fullDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']

    let dt = new Date(dateTime),
    date = dt.getDate(),
    diffDays = new Date().getDate() - date,
    diffMonths = new Date().getMonth() - dt.getMonth(),
    diffYears = new Date().getFullYear() - dt.getFullYear()

    if (diffYears === 0 && diffMonths === 0 && diffDays === 0) return 'Today'
    else if (diffYears === 0 && diffMonths === 0 && diffDays === 1) return 'Yesterday'
    else if (diffYears === 0 && diffMonths === 0 && (diffDays > 1 && diffDays < 7)) return fullDays[dateTime.getDay()] 
    else if (diffYears === 0 && diffMonths === 0 && (diffDays >= 7 && diffDays < 14)) return 'Last week'
    else if (diffYears === 0 && diffMonths === 0 && diffDays >= 14) return 'This month'
    else if (diffYears === 0 && diffMonths === 1) return 'Last month'
    else if (diffYears === 0 && diffMonths > 1) return 'Over 1 month'
    else if (diffYears === 1 && diffMonths >= 0) return 'A year ago'
    else if (diffYears === 1 && diffMonths < 0) return 'Last year'
    else return 'Over a year'
}

function sortArrayOfObjects (array: any[], sortBy: string) {
    array.sort((a, b) => {
        let x = a[sortBy].toLowerCase(),
            y = b[sortBy].toLowerCase();
    
        if (x < y) {
            return -1;
        }
        if (x > y) {
            return 1;
        }
        return 0;
    });

    return array
}

const setSessionExpiryTime = (expiryMins = appSettings.SESSION_EXPIRATION_LENGTH) => {
    const date = new Date()
    //date.setTime( date.getTime() - new Date().getTimezoneOffset() * 60 * 1000 );
    date.setMinutes(date.getMinutes() + expiryMins)
    localStorage.setItem('session-expiry-time', date.toString())
}

const validatePassword = (password: string): boolean => {
    var regex = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
    return regex.test(password);
}

export const getDateDifferenceInDays = (date: string) => {
    let today = new Date()
    let formattedDate = new Date(date)
    today.setHours(0, 0, 0, 0)

    const diff = (formattedDate.valueOf() - today.valueOf()) / (1000 * 3600 * 24)

    return Math.round(diff)
}

export const getTheme = (colors: any) => {
    const theme = {
        '#0D968F': colors.primaryColor1,
        "#0EA59D": colors.primaryColor1,
        '#1A2C37': colors.primaryColor2,
        '#0A756F': colors.primaryColor1,
        '#69BBBA': convertHexToRGBA(colors.primaryColor1, 0.5),
        '#5EC3BD': convertHexToRGBA(colors.primaryColor1, 0.6),
        '#E7F6F5': colors.secondaryColor1,
        '#B4E3E1': colors.secondaryColor2,
        '#C9F3F0': colors.secondaryColor2,
        '#E1FFFD': colors.secondaryColor1,
        '#25C5BC': colors.primaryColor1,
        '#0D5B57': colors.primaryColor1,
        '#0E4915': colors.primaryColor1,
        '#3AAF4B': colors.primaryColor1,
        '#BEE6E3': colors.secondaryColor2,
        '#219993': colors.secondaryColor2,
        'rgba(26,44,55, 0.95)': convertHexToRGBA(colors.primaryColor2, 0.95), // primaryColor 2 
        'rgba(13, 150, 143, 0.5)': convertHexToRGBA(colors.primaryColor1, 0.5),
        '#F2FFFE': convertHexToRGBA(colors.secondaryColor1, 0.7),
        '#CDFFFC': colors.secondaryColor1,
        '#DCFFFD': convertHexToRGBA(colors.secondaryColor1, 0.7),
        '#F4FFFE': convertHexToRGBA(colors.secondaryColor1, 0.7),
        '#CCF3F1': convertHexToRGBA(colors.secondaryColor2, 0.6),
        '#085B56': colors.primaryColor1
    }

    return theme
}

export const extractInstitutionTheme = (data: InstitutionData) => {
    const colors = {
        primaryColor1:  data?.primaryColour || '#0D968F',
        primaryColor2:  data?.primaryColour2 || '#1A2C37',
        secondaryColor1: data?.secondaryColour || '#E7F6F5',
        secondaryColor2: data?.secondaryColour2 || '#B4E3E1'
    }

    return getTheme(colors)
}

const getInputValidDate = () => {
    let dtToday = new Date()

    let [month, day, year]: Array<any> =  [
        dtToday.getMonth() + 1,
        dtToday.getDate(),
        dtToday.getFullYear()
    ]

    if (month < 10) month = `0${month}`
    if (day < 10) day = `0${day}`

    return `${year}-${month}-${day}`
}

const addPrevMomentToDate = (duration: number, period: string): string => {
    const initiaDate = new Date()

    if (period === 'hours') {
        initiaDate.setHours(initiaDate.getHours() - duration)
    }
    else if (period === 'days') {
        initiaDate.setDate(initiaDate.getDate() - duration)
    }
    else if (period === 'months') {
        initiaDate.setMonth(initiaDate.getMonth() - duration)
    }
    else if (period === 'years') {
        initiaDate.setFullYear(initiaDate.getFullYear() - duration)
    }

    return initiaDate.toISOString()
}

// compressBase64 function has not been tested to be working as expected
export const compressBase64 = async (base64String: string, maxSizeKB = 400) => {
    try {
        // Decode base64 string to binary data
        const binaryData = atob(base64String);
    
        // Convert binary data to Uint8Array
        const dataArray = new Uint8Array(binaryData.length);
        for (let i = 0; i < binaryData.length; i++) {
            dataArray[i] = binaryData.charCodeAt(i);
        }
    
        // Compress the binary data
        const compressedData = pako.gzip(dataArray);
    
        // Convert compressed data to base64 string
        const compressedBase64 = btoa(String.fromCharCode.apply(null, compressedData));
    
        // Ensure the compressed size is within the specified limit
        if (compressedBase64.length / 4 * 3 > maxSizeKB * 1024) {
            console.warn('Compression did not achieve the desired size reduction.');
            return ''
        }

        console.log({compressedBase64})
    
        return compressedBase64;
    }
    catch (err: any) {
        console.log({compressionError: err.message})
        return ''
    }
};

export const convertToTitleCase = (str: string) => {
    if (!str.length) return "";
    return str
      .split("_") // Split by underscores
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each word
      .join(" "); // Join words with space
  };

export const compressImage = async (image: any, maxSizeMB = 0.39) => {
    const file = image //e.target.files[0];

    try {
        const options = {
            maxSizeMB,
            //maxWidthOrHeight: 800,
            useWebWorker: true,
        };

        const compressedFile = await imageCompression(file, options);

        console.log({compressedFile})

        return compressedFile
    } catch (err: any) {
        console.error('Error compressing image:', err.message);
        return ''
    }
};

const validateTxAmount = (data: [], acctNumber: string, amount: number|string) => {
    const response = {isValidated: true, message: ''}
    const acctDetails = getAccountDetailsByParam(data, 'nuban', acctNumber)

    if (Number(amount) > acctDetails?.balance?.withdrawableAmount) {
        response.isValidated = false
        response.message = 'Insufficient Funds'
    }

    if (Number(amount) <= 0) {
        response.isValidated = false
        response.message = 'Invalid Amount'
    }

    return response
}

const getFileExtension = (file: string) => {
    const splittedFileName = file.split('.')
    let extension = splittedFileName[splittedFileName.length - 1].toLowerCase()

    return extension === 'svg' ? 'png' : extension
}

const convertUTCToLocalTime = (
  date = "0000-01-01T00:00:00Z",
  dateOnly = false
) => {
  // Assuming you have a UTC date string
  console.log({ date });
  const utcDate = new Date(date);

  // Convert to local date and time string in the system's time zone
  if (dateOnly) {
    const localDateString = utcDate.toLocaleDateString(undefined, {
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    });
    console.log({ localDateString });
    return localDateString;
  } else {
    const localDateString = utcDate.toLocaleString(undefined, {
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    });
    console.log({ localDateString });
    return localDateString;
  }
};

const generateAvailableTenures = (maxTenure: number) => {
    const MIN_MULTI_OPTION_TENURE = 30
    if (maxTenure <= MIN_MULTI_OPTION_TENURE) {
        return [{ value: maxTenure.toString(), label: `${maxTenure} days` }]
    }
    const standardOptions = [
        { value: '30', label: '30 days' },
        { value: '60', label: '60 days' },
        { value: '90', label: '90 days' },
        { value: '120', label: '4months' },
        { value: '150', label: '5months' },
        { value: '180', label: '6months' },
        { value: '210', label: '7months' },
        { value: '240', label: '8months' },
        { value: '270', label: '9months' },
        { value: '300', label: '10months' },
        { value: '330', label: '11months' },
        { value: '365', label: '1year' },
    ]
    return standardOptions.filter(
        (option) => parseInt(option.value) <= maxTenure,
    )
}

const computeFixedDepositData = (amount: number, tenure: number, interestRate: number, startDate: Date) => {
    const acruedInterest = (((amount * interestRate) / 100) * tenure) / 365
    const expectedReturn = amount + acruedInterest
    const maturationDate = startDate
    maturationDate.setDate(startDate.getDate() + tenure)

    return {
        acruedInterest,
        expectedReturn,
        maturationDate: maturationDate.toISOString()
    }
}


export default {
    inputValidator,
    validateEmail,
    isValidFileType,
    searchTableData,
    hashString,
    convertFileToBase64,
    splitDateTime,
    getAccountDetailsWithAcctNo,
    getAccountDetailsByParam,
    getDateTime,
    getCardExpiryDate,
    formatNotification,
    validatePhoneNo,
    validateBvn,
    getFileSize,
    convertHexToRGBA,
    setSessionExpiryTime,
    validatePassword,
    getDateDifferenceInDays,
    extractInstitutionTheme,
    convertDateTimeToSystemFormat,
    getInputValidDate,
    addPrevMomentToDate,
    compressBase64,
    compressImage,
    ConvertBase64toFile,
    validateTxAmount,
    getFileExtension,
    convertUTCToLocalTime,
    generateAvailableTenures,
    computeFixedDepositData,
    convertToTitleCase
}
